import React, { useEffect, useState } from "react";
import $ from 'jquery';
import bootbox from 'bootbox';
import Toastr from 'toastr';
import logo from "./../assets/img/favicon-dark.png";

function ForgotPassword() {

  let host_name = window.location.protocol + '//' + window.location.host;
  const [user_login, setUserLogin] = useState("");

  useEffect(() => {
    var loadScript = function (src) {
      var tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(tag);
    }
    loadScript('https://www.google.com/recaptcha/api.js?render=6LfoaGsbAAAAAD3li16lM-UuG8YuI_JEyfewYwp3');
  }, []);

  const handleInputChange = (e) => {
    const target = e.target;

    switch (target.name) {
      case "user_login":
        setUserLogin(target.value)
        break;

      default:
        break;
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    if ($('.btn-reset-pwd').hasClass('btn-loading')) {
      return;
    }
    $('.btn-reset-pwd').addClass('btn-loading');

    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LfoaGsbAAAAAD3li16lM-UuG8YuI_JEyfewYwp3', { action: 'submit' }).then(function (token) {

        $.ajax(
          {
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/reset-pwd-challenge',
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
              operation: 'password-recovery',
              form_input: {
                host_name: host_name,
                user_login: user_login,
                token: token
              }
            }),
            dataType: "json"
          }
        ).then((res) => {
          if (res && res.status) {
            switch (res.status.code) {
              case 200:
                if (res.data.ResponseMetadata) {
                  bootbox.alert('An email with password reset instructions has been sent to your email account successfully!', () => {
                    window.location = "/";
                  });
                } else {
                  Toastr.error('Failed to trigger an email ... Please try again !');
                }
                break;

              case 201:
                Toastr.error('No such user account exists !');
                break;

              case 400:
                if (res.status.message === 'INVALID-USER') {
                  Toastr.error('No such user account exists !');
                } else if (res.status.message === 'ROBOT') {
                  Toastr.error('Looks like robot ... Too many attempts  !');
                }
                break;

              default:
                Toastr.error('Attempt failed ... Please try again !');
                break;
            }

          } else {
            Toastr.error('Attempt failed ... Please try again !');
          }
          $('.btn-reset-pwd').removeClass('btn-loading');
        }, (err) => {
          $('.btn-reset-pwd').removeClass('btn-loading');
          Toastr.error('Attempt failed ... Please try again !')
        });

      });
    });
  }

  return (
    <React.Fragment>
      <div className="container mt-5" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <div className="row">
          <div className="col-md-12 col-xs-12 p-2">
            <div className="text-center">
              <span className="logo-font font-size-20 text-app-2 strong">
                <img
                  className="pb-1 "
                  src={logo}
                  alt="logo"
                  style={{ width: "30px", marginRight: "10px" }}
                />
                SiteSupt OnDemand
              </span>
            </div>
            <br />
            <div className="card m-4" style={{ width: "20rem" }}>
              <div className="card-body">
                <h6 className="text-center text-bold">Forgot Password ?</h6>
                <div className="card-text" style={{ color: '#777777' }}>Enter your username and we will send you a link to the associated email account to reset your password.</div>
                <div className="d-flex align-items-center flex-column mt-5">
                  <div>
                    <label className="py-0 my-0 mt-3 text-app-2 font-size-16"> Username </label>
                    <input
                      className="form-control"
                      style={{ width: "18rem" }}
                      type="text"
                      name="user_login"
                      value={user_login}
                      onChange={handleInputChange}
                      autoComplete="off"
                      placeholder="User Name"
                    />
                  </div>
                </div>
                <div className="text-right">
                  <button disabled={!(user_login).trim().length > 0} className="btn btn-sm btn-app-2 mt-2 btn-reset-pwd" onClick={(e) => onFormSubmit(e)}>Submit</button>
                </div>
                <div className="left-right mt-3">
                  <i className="fas fa-arrow-left text-app-2"></i>
                  <a href="./"> Back to Login </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default ForgotPassword;
